module.exports = __webpack_public_path__ + "img/googlePhoneScreenshot.e289346e.png";